import { DocumentFilters } from 'interfaces';

export const encodeFiltersToBase64 = (filters: DocumentFilters): string | null => {
  const payload: Array<{ column: string; operator: string; value: any }> = [];

  if (filters.name && filters.name.trim()) {
    payload.push({ column: 'name', operator: 'ilike', value: filters.name.trim() });
  }

  if (filters.status && filters.status.length > 0) {
    payload.push({ column: 'status', operator: 'in', value: filters.status });
  }

  if (filters.dateFrom || filters.dateTo) {
    const range: Record<string, string> = {};
    if (filters.dateFrom) {
      range.gte = filters.dateFrom.includes('T')
        ? filters.dateFrom
        : `${filters.dateFrom}T00:00:00.000Z`;
    }
    if (filters.dateTo) {
      range.lt = filters.dateTo.includes('T')
        ? filters.dateTo
        : `${filters.dateTo}T23:59:59.999Z`;
    }
    payload.push({ column: 'upload_at', operator: 'range', value: range });
  }

  if (!payload.length) return null;

  const bytes = new TextEncoder().encode(JSON.stringify(payload));
  return btoa(Array.from(bytes, b => String.fromCharCode(b)).join(''));
};
